var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLyftCustomerLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 32,
    viewBox: "0 0 44 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_27590_76343)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00939941 0.558439H6.58575V18.9844C6.58575 21.9004 7.86337 23.6374 8.87371 24.382C7.80411 25.3746 4.53561 26.2432 2.09913 24.1337C0.662657 22.8903 0.00939941 20.8456 0.00939941 18.9223V0.558439ZM41.1089 15.8645V13.9281H43.1146V7.13477H40.912C40.0665 3.05622 36.5884 0 32.4288 0C27.637 0 23.7527 4.05548 23.7527 9.05788V24.9224C25.1178 25.1226 26.7442 24.8974 28.128 23.6995C29.5642 22.4559 30.2174 20.4115 30.2174 18.4881V17.9036H33.5019V11.1103H30.2174V9.05788H30.2253C30.2253 7.78751 31.2118 6.75768 32.4288 6.75768C33.6457 6.75768 34.636 7.78751 34.636 9.05788V15.8645C34.636 20.8669 38.5245 24.9224 43.3161 24.9224V18.1647C42.0993 18.1647 41.1089 17.1348 41.1089 15.8645ZM16.202 7.13477V17.1046C16.202 17.6707 15.7521 18.1295 15.1971 18.1295C14.6421 18.1295 14.1923 17.6707 14.1923 17.1046V7.13477H7.68504V18.8604C7.68504 20.9697 8.37025 23.6374 11.4885 24.506C14.6099 25.3755 16.4207 23.5755 16.4207 23.5755C16.2557 24.7613 15.1859 25.63 13.4627 25.8161C12.1588 25.9568 10.4913 25.5059 9.6595 25.1337V31.3459C11.779 31.9984 14.0207 32.2092 16.2146 31.7648C20.1961 30.9583 22.7089 27.4841 22.7089 22.8619V7.13477H16.202Z",
    fill: "#FF0590"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_27590_76343"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43.3067,
    height: 32,
    fill: "white",
    transform: "translate(0.00939941)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLyftCustomerLogo);
export default __webpack_public_path__ + "static/media/lyft-customer-logo.cf960bacce0b62375e032ec5b16a592f.svg";
export { ForwardRef as ReactComponent };